import {RootStore} from '../../stores/RootStore';
import {WidgetEventHandler} from './types';
import {getCtaButtonClickHandler} from './getCtaButtonClickHandler';
import {getAppErrorHandler} from './getAppErrorHandler';
import {PanoramaTransactions} from '../../../../constants/app';

const openNotifyMeModal = async (rootStore: RootStore): Promise<void> => {
  const productId = rootStore.$state.product.id;
  const variantId = rootStore.$state.variantId;
  const errorHandler = getAppErrorHandler(rootStore);

  try {
    await rootStore.ecomPublicApi.backInStock.openBackInStockEmailModal({productId, variantId});
  } catch (error) {
    /* istanbul ignore next reason: no need to check  */
    await errorHandler(error);
  }
};

export const handleNotifyMeClick = (rootStore: RootStore): WidgetEventHandler<any> => {
  return getCtaButtonClickHandler(rootStore, () =>
    rootStore.reportPanoramaTransaction(PanoramaTransactions.NotifyMe, () => openNotifyMeModal(rootStore)),
  );
};
